export default {
  'disablements': 'Disablements',
  'search.customers': 'Search customers',
  'search.results': 'Search results',
  'towingNeeded': 'Towing Needed',
  'towingNotNeeded': 'Towing Not Needed',
};